import { validationMixin } from "vuelidate";
import { get } from "lodash";

export default {
  mixins: [validationMixin],
  methods: {
    strongPassword(value) {
      const containsUppercase = /[A-Z]/.test(value);
      const containsLowercase = /[a-z]/.test(value);
      const containsNumber = /[0-9]/.test(value);
      const containsSpecial = /[#?!@$%^&*-]/.test(value);
      const isValid =
        containsUppercase &&
        containsLowercase &&
        containsNumber &&
        containsSpecial;
      return isValid || "Please use combination password";
    },
    fieldErrors(name, messagesName = "") {
      let rule;
      const errors = [];
      const field = get(this.$v, name);
      const messages = messagesName
        ? get(this.$options.validationMessages, messagesName)
        : get(this.$options.validationMessages, name);

      if (!field.$dirty) return errors;

      if (messages) {
        for (rule in messages) {
          if (field[rule] === false && messages[rule]) {
            errors.push(messages[rule]);
          }
        }
      }
      return errors;
    },
  },
};
